import type { LovedOnesQuery, AddLovedOneMutationVariables } from '@/gql/graphql';

export type PaginatedLovedOneTypeResponse = Extract<LovedOnesQuery['lovedOnes'], {}>;
export type LovedOne = Extract<PaginatedLovedOneTypeResponse['rows'], {}>[number] & {
  otherRelationship?: string;
  isEmailValid?: boolean;
};
export type PhoneInfoType = Extract<LovedOne['phoneInfo'], {}>;
export type LovedOneInput = Extract<AddLovedOneMutationVariables['data'], {}>;

export enum FamilyRelationship {
  Assistant = 'Assistant',
  Brother = 'Brother',
  BrotherInLaw = 'Brother-In-Law',
  Caregiver = 'Caregiver',
  Daughter = 'Daughter',
  Father = 'Father',
  FatherInLaw = 'Father-In-Law',
  Friend = 'Friend',
  Granddaughter = 'Granddaughter',
  Grandfather = 'Grandfather',
  Grandmother = 'Grandmother',
  Grandson = 'Grandson',
  Husband = 'Husband',
  Mother = 'Mother',
  MotherInLaw = 'Mother-In-Law',
  Nephew = 'Nephew',
  Niece = 'Niece',
  NurseCaretaker = 'Nurse / Caretaker',
  Other = 'Other',
  Partner = 'Partner',
  Pastor = 'Pastor',
  Sister = 'Sister',
  SisterInLaw = 'Sister-In-Law',
  Son = 'Son',
  Wife = 'Wife',
}
